module.exports = "/images/tos.svg?bb90c81f107f213d94b13fc6a290ab62";